/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Text_TxtInputs */

const en_text_txt = /** @type {(inputs: Text_TxtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text (.txt)`)
};

const fr_text_txt = /** @type {(inputs: Text_TxtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texte (.txt)`)
};

const de_text_txt = /** @type {(inputs: Text_TxtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text (.txt)`)
};

const it_text_txt = /** @type {(inputs: Text_TxtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testo (.txt)`)
};

const ru_text_txt = /** @type {(inputs: Text_TxtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текст (.txt)`)
};

const es_text_txt = /** @type {(inputs: Text_TxtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto (.txt)`)
};

const zh_cn2_text_txt = /** @type {(inputs: Text_TxtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文本（.txt）`)
};

const ja_text_txt = /** @type {(inputs: Text_TxtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキスト（.txt）`)
};

const hi_text_txt = /** @type {(inputs: Text_TxtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टेक्स्ट (.txt)`)
};

const pt_pt2_text_txt = /** @type {(inputs: Text_TxtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto (.txt)`)
};

/**
* | output |
* | --- |
* | "Text (.txt)" |
*
* @param {Text_TxtInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const text_txt = /** @type {((inputs?: Text_TxtInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Text_TxtInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_text_txt(inputs)
	if (locale === "de") return de_text_txt(inputs)
	if (locale === "it") return it_text_txt(inputs)
	if (locale === "ru") return ru_text_txt(inputs)
	if (locale === "es") return es_text_txt(inputs)
	if (locale === "zh-CN") return zh_cn2_text_txt(inputs)
	if (locale === "ja") return ja_text_txt(inputs)
	if (locale === "hi") return hi_text_txt(inputs)
	if (locale === "pt-PT") return pt_pt2_text_txt(inputs)
	return en_text_txt(inputs)
});